import { Store } from 'vuex'
import { Route, RawLocation } from 'vue-router'

export interface IMiddlewareContext {
  to: Route
  from: Route
  next: (to?: RawLocation) => void
  store: Store<any>
  nextMiddleware?: () => any
}

export const middlewarePipeline = (context: any, middlewares: Function[]) => {
  const [nextMiddleware, ...restMiddlewares] = middlewares

  if (!nextMiddleware) {
    return context.next
  }

  return (to?: any) => {
    if (to) return context.next(to)
    const nextPipeline = middlewarePipeline(
      context, restMiddlewares
    )

    nextMiddleware({ ...context, nextMiddleware: nextPipeline })
  }
}
